import { render, staticRenderFns } from "./tabsPane.vue?vue&type=template&id=12d01ab2&scoped=true"
import script from "./tabsPane.vue?vue&type=script&lang=js"
export * from "./tabsPane.vue?vue&type=script&lang=js"
import style0 from "./tabsPane.vue?vue&type=style&index=0&id=12d01ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d01ab2",
  null
  
)

export default component.exports